import {Grid, Typography} from '@mui/material';
import CreateLeaveRequestForm from 'viewComponents/CreateLeaveRequestForm';
import {useTranslation} from 'react-i18next';
import LeavesBalance from 'viewComponents/LeavesBalance/LeavesBalance';
import LeaveRequestsTable from 'viewComponents/LeaveRequestsTable/LeaveRequestsTable';
import AditionalLeavesBalance from 'viewComponents/AditionalLeavesBalance/AditionalLeavesBalance';
import MonetizedDaysBalance from 'viewComponents/MonetizedDaysBalance/MonetizedDaysBalance';
import VacationRulesList from 'viewComponents/VacationRulesList/VacationRulesList';

export const MyLeaves = () => {
  const {t} = useTranslation();
  return (
    <div className="w-full flex flex-col flex-wrap pt-4 lg:pt-12">
      <Typography variant="h4">{t('leaves.MyLeaves.title')}</Typography>
      <Typography variant="body1">
        {t('leaves.MyLeaves.description')}
      </Typography>
      <Grid
        container
        spacing={{xs: 2, lg: 4}}
        sx={{marginTop: '1rem !important'}}
      >
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* Left Section */}
            <Grid item xs={12} lg={7}>
              <CreateLeaveRequestForm />
            </Grid>
            {/* Right Section */}
            <Grid item xs={12} lg={5}>
              <LeavesBalance />
              <VacationRulesList className="mt-6" />
              <div className="help-text mt-6 px-4">
                <Typography variant="body1">
                  {t('leaves.help_title')}
                </Typography>
                <Typography variant="body2">
                  {t('leaves.help_description')}
                </Typography>
              </div>
              <AditionalLeavesBalance className="mt-6" />
              <MonetizedDaysBalance className="mt-6" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <LeaveRequestsTable />
        </Grid>
      </Grid>
    </div>
  );
};

export default MyLeaves;
